import styled, { keyframes } from 'styled-components';

export const Container = styled.div`
	overflow: hidden;
	height: 40px;
`;

const change = keyframes`0%,
	22%,
	100% {
		transform: translate3d(0, 0, 0);
	}
	44% {
		transform: translate3d(0, -33%, 0);
	}
	66% {
		transform: translate3d(0, -66%, 0);
	}
	88% {
		transform: translate3d(0, -33%, 0);
	}
`;

export const List = styled.ul`
	margin-top: 0;
	text-align: center;
	list-style: none;
	animation-name: ${change};
	animation-duration: 10s;
	animation-iteration-count: infinite;
`;

export const ListItem = styled.li`
	line-height: 40px;
`;
